import React, { FC, ReactNode } from "react";
import { debounce } from 'lodash';
import { TextInput } from "./TextInput";
import { KeyboardKey } from "../constants/KeyboardKey";
import { observer } from "mobx-react-lite";

export interface EditableLabelProps {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  label: ReactNode;
  value: string;
  setValue: (value: string) => void;
}

export const EditableLabel: FC<EditableLabelProps> = observer(({isEditing, setIsEditing, label, value, setValue}) => {

  const handleChange = debounce((inputValue: string) => {
    if (inputValue.trim().length === 0) return;
    setValue(inputValue);
  }, 200);

  const exitEditMode = () => {
    setIsEditing(false);
  };

  if (!isEditing) {
    return (<>{label}</>);
  }

  return (
    <TextInput
      value={ value }
      onChange={ handleChange }
      onKeyDown={ {
        [KeyboardKey.ENTER]: exitEditMode,
        [KeyboardKey.ESCAPE]: exitEditMode,
      } }
      onBlur={ exitEditMode }
      onFocus={ (e) => (e.target as HTMLInputElement).select() }
    />
  );
});
